// Local translations
export const T = {
  en_GB: {
    editTitle: "Edit Combined Instrument",
    createTitle: "Add Combined Instrument",
    editDescription: "Update the combined instrument configuration.",
    createDescription: "Create a new combined instrument with weighted allocations.",
    name: "Name",
    namePlaceholder: "e.g., Global Equity Portfolio",
    nameHelp: "Name must be between 5 and 255 characters",
    isin: "ISIN",
    isinPlaceholder: "e.g., NO0012345678",
    isinHelp: "International Securities Identification Number (max 12 characters)",
    currency: "Currency",
    selectCurrency: "Select currency",
    instruments: "Instruments",
    instrumentsHelp:
      "Add instruments with their weight allocations (must sum to 100%). Legs in another currency are converted to the basket currency unless marked hedged.",
    instrumentName: "Instrument",
    hedged: "Hedged",
    hedgedHelp:
      "Hedged: the leg's raw prices are used and its returns count as returns in the basket currency. Unhedged: the leg is converted into the basket currency using daily FX rates.",
    weight: "Weight (%)",
    addInstrument: "Add Instrument",
    removeInstrument: "Remove",
    totalWeight: "Total Weight",
    weightError: "Total weight must equal 100%",
    noInstruments: "No instruments added. Click 'Add Instrument' to search and add instruments.",
    minInstruments: "At least two instruments are required.",
    cancel: "Cancel",
    save: "Save",
    addCombinedInstrument: "Add Combined Instrument",
    patchInstrument: "Patch",
    failedToSave: "Failed to save combined instrument",
    instrumentAlreadyAdded: "This instrument has already been added",
    loading: "Loading...",
  },
  nb_NO: {
    editTitle: "Rediger kombinert instrument",
    createTitle: "Legg til kombinert instrument",
    editDescription: "Oppdater konfigurasjonen for det kombinerte instrumentet.",
    createDescription: "Opprett et nytt kombinert instrument med vektede allokeringer.",
    name: "Navn",
    namePlaceholder: "f.eks. Global aksjeportefølje",
    nameHelp: "Navnet må være mellom 5 og 255 tegn",
    isin: "ISIN",
    isinPlaceholder: "f.eks. NO0012345678",
    isinHelp: "Internasjonalt verdipapiridentifikasjonsnummer (maks 12 tegn)",
    currency: "Valuta",
    selectCurrency: "Velg valuta",
    instruments: "Instrumenter",
    instrumentsHelp:
      "Legg til instrumenter med vektallokeringer (må summere til 100%). Legs i en annen valuta konverteres til kurvens valuta med mindre de er merket som hedget.",
    instrumentName: "Instrument",
    hedged: "Hedget",
    hedgedHelp:
      "Hedget: leggens rå priser brukes og avkastningen regnes som avkastning i kurvens valuta. Ikke hedget: leggen konverteres til kurvens valuta med daglige valutakurser.",
    weight: "Vekt (%)",
    addInstrument: "Legg til instrument",
    removeInstrument: "Fjern",
    totalWeight: "Total vekt",
    weightError: "Total vekt må være lik 100%",
    noInstruments:
      "Ingen instrumenter lagt til. Klikk 'Legg til instrument' for å søke og legge til instrumenter.",
    minInstruments: "Minst to instrumenter er påkrevd.",
    cancel: "Avbryt",
    save: "Lagre",
    addCombinedInstrument: "Legg til kombinert instrument",
    patchInstrument: "Patch",
    failedToSave: "Kunne ikke lagre kombinert instrument",
    instrumentAlreadyAdded: "Dette instrumentet er allerede lagt til",
    loading: "Laster...",
  },
} as const;
